import {OccNotificationConfig} from '@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/config/notification'
import {defaultOccNotificationConfig} from '@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/config/notification'

export function getNotificationConfigData():OccNotificationConfig {
    return {
        dismissalTime: defaultOccNotificationConfig.dismissalTime
    }
}